















import Vue from 'vue'
import {ThisTypedComponentOptionsWithRecordProps} from 'vue/types/options'
import UiModal from '@/components/ui/UiModal.vue'
import {mapGetters, mapMutations} from "vuex";
import {storeModuleName} from "@/store/modules/ui";
import {BASE_PATH} from "@/requests/requestMachine";
import {getAccessToken} from "@/utils/plugins/jwt";

interface Data {
  iframe: any
  frame: any
  loading: boolean
}

interface Methods {
  setBookingOnlineModalStatus: (value: boolean) => void
  setBookingOnlineModalId: (value: string | number | null) => void
}

interface Computed {
  refModal: any
}

interface Props {
}

declare module 'vue/types/vue' {
  interface Vue {
    getSrc: (id: string | number | null) => void;
  }
}

export default Vue.extend({
  name: 'UiBookingOnlineModal',
  components: {
    UiModal
  },
  data() {
    return {
      loading: false,
      frame: null,
      iframe: {
        src: '',
        style: null,
        wrapperStyle: null,
      },
    }
  },
  computed: {
    refModal() {
      return (this.$refs as any).modal
    },
    ...mapGetters(storeModuleName, ['bookingOnlineModalStatus', 'bookingOnlineModalId']),
  },
  watch: {
    bookingOnlineModalStatus(val: boolean) {
      if (val) {
        this.refModal.open()
      }
    },
    bookingOnlineModalId(val: string | number | null) {
      this.getSrc(val);
    },
  },
  methods: {
    onModalClose() {
      this.setBookingOnlineModalStatus(false)
      this.setBookingOnlineModalId(null)
    },
    async getSrc(bookingId: string | number | null) {
      if (bookingId) {
        this.loading = true;

        const url = BASE_PATH + '/booking/v1/online-payment/?id=' + bookingId + '&accessToken=' + getAccessToken();
        const data = await fetch(url)
            .catch(err => {
              let error = null;

              if (err['message']) {
                error = err['message']
              } else if (err['errorMessage'] || err['detail']) {
                error = err['errorMessage'] || err['detail']
              }

              alert(error ? error : err.message);
            })
            .finally(() => this.loading = false);

        if (data) {
          const res = await data.json();

          if (res['type']) {
            if (res['type'] === 'smsCodeRequired') {
              const code = prompt(res['message'])

              if (code) {
                this.loading = true;
                const smsData = await fetch(url + '&confirmsms=' + code)
                    .catch(err => {
                      alert(err.message);
                    })
                    .finally(() => this.loading = false);

                if (smsData) {
                  const smsRes = await smsData.json();
                  let error = null;

                  if (smsRes['message']) {
                    error = smsRes['message']
                  } else if (smsRes['errorMessage'] || smsRes['detail']) {
                    error = smsRes['errorMessage'] || smsRes['detail']
                  }

                  if (error) {
                    alert(error)
                    this.refModal.close()
                    return;
                  }

                  // this.frame = res['iframe']
                  this.iframe.src = smsRes['src'];
                  // window.open(smsRes['src']);
                  // this.refModal.close()
                }
              }

              return;
            }

            let error = null;

            if (res['message']) {
              error = res['message']
            } else if (res['errorMessage'] || res['detail']) {
              error = res['errorMessage'] || res['detail']
            }

            if (error) {
              alert(error)
              this.refModal.close()
              return;
            }
          }

          // this.frame = res['iframe']
          this.iframe.src = res['src'];
          // window.open(res['src']);
          // this.refModal.close()
        }
      }
    },
    ...mapMutations(storeModuleName, ['setBookingOnlineModalStatus', 'setBookingOnlineModalId']),
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
